import { render, staticRenderFns } from "./avatar-icon.svg.vue?vue&type=template&id=3952067a&"
import script from "./avatar-icon.svg.vue?vue&type=script&lang=js&"
export * from "./avatar-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports